/**
 * 模版-瀑布流组件
 * @author VenDream
 * @since 17/12/11
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import debounce from '@fe/common/lib/debounce';
import Waterfall from 'components/waterfall/waterfall';
import StoreTplBox from 'containers/store-tpl-box/store-tpl-box';

import VARIABLES from 'constants/variable.json5';

// 小屏尺寸
const SMALL_SCREEN_WIDTH = 1366;
// 不同屏幕的布局配置
const CONFIG = {
  small: { column: 4, gutter: 38 },
  large: { column: 5, gutter: 30 },
};

// 海报模板默认宽度
const POSTER_WIDTH = 214;
const POSTER_INFO_HEIGHT = 90;

/**模板信息底部栏高度 */
const TPL_INFO_BOTTOM_HEIGHT = 35;

// 模版盒子高度
const BOX_HEIGHT = {
  [VARIABLES.RP_H5]: 430,
  [VARIABLES.RP_SPA]: 430,
  [VARIABLES.POSTER]: 430,
  [VARIABLES.RP_VIDEO]: {
    horizontal: 212,
    square: 306,
    vertical: 474,
  },
  [VARIABLES.RP_GAME]: 390,
};

class TplWaterfall extends Component {
  static propTypes = {
    // 瀑布流模版数据
    tpls: PropTypes.array,
    // 模版分类
    category: PropTypes.string,
    // 瀑布流配置
    column: PropTypes.number,
    gutter: PropTypes.number,
    // 前置初始数据
    initItems: PropTypes.array,
    // 是否禁用适应宽度布局
    isDisabledWidthConfig: PropTypes.bool,
  };

  static defaultProps = {
    tpls: [],
    category: '',
    column: 5,
    gutter: 30,
    initItems: [],
    isDisabledWidthConfig: false,
  };

  constructor() {
    super();

    // 接管瀑布流配置，由屏幕大小决定初始布局
    this.state =
      getWinWidth() <= SMALL_SCREEN_WIDTH
        ? { ...CONFIG.small }
        : { ...CONFIG.large };

    this.reconstruct = debounce(this.reconstruct.bind(this), 100);
  }

  componentDidMount() {
    this.resetConfigWidth();
    window.addEventListener('resize', this.reconstruct);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.reconstruct);
  }

  // 自适应布局
  reconstruct() {
    const { isDisabledWidthConfig } = this.props;
    if (isDisabledWidthConfig) {
      return;
    }
    const newState =
      getWinWidth() <= SMALL_SCREEN_WIDTH
        ? { ...CONFIG.small }
        : { ...CONFIG.large };

    this.setState(newState);
  }

  // 设置布局宽度
  resetConfigWidth() {
    const { isDisabledWidthConfig } = this.props;
    // 禁用自适应布局
    if (isDisabledWidthConfig) {
      const newConfigState = { ...CONFIG.large };
      this.setState(newConfigState);
    }
  }

  // 渲染瀑布流
  getTplWaterfall() {
    const { column, gutter } = this.state;
    const { tpls, category, initItems } = this.props;
    let tplBoxes = Array.from(initItems);
    for (const tpl of tpls) {
      const { type, videoWidth, videoHeight, height, width, price } = tpl;

      // 海报模板隐藏模板信息的底部栏，免费模板增加左上角免费标签
      const isFreePosterTpl = type === VARIABLES.POSTER && price === 0;
      const hideBottom =
        type === VARIABLES.POSTER || category === VARIABLES.ENTERPRISE;

      const posterRatio = width && height ? width / height : null;

      const posterInfoHeight = hideBottom
        ? POSTER_INFO_HEIGHT - TPL_INFO_BOTTOM_HEIGHT
        : POSTER_INFO_HEIGHT;
      const posterHeight = posterRatio
        ? Math.floor(POSTER_WIDTH / posterRatio) + posterInfoHeight
        : BOX_HEIGHT[type];
      let boxHeight = 0;

      const content = (
        <StoreTplBox
          key={tpl.id}
          id={tpl.id}
          category={category}
          hasTopFreeTag={isFreePosterTpl}
          hideBottom={hideBottom}
        />
      );

      // 计算盒子高度
      if (type === VARIABLES.RP_VIDEO) {
        /* 一视模版 */

        // 判断模版形状[横版、方形和竖版]
        const shape =
          videoWidth === videoHeight
            ? 'square'
            : videoWidth > videoHeight
            ? 'horizontal'
            : 'vertical';

        boxHeight = BOX_HEIGHT[VARIABLES.RP_VIDEO][shape];
      } else if (type === VARIABLES.POSTER) {
        /* 海报 */
        boxHeight = posterHeight;
      } else {
        /* 翻页模版or长页模版 */
        boxHeight = BOX_HEIGHT[type];
      }

      const tplBox = { height: boxHeight, content };
      tplBoxes.push(tplBox);
    }

    return <Waterfall items={tplBoxes} column={column} gutter={gutter} />;
  }

  render() {
    return (
      <div className="cmp tpl-waterfall transitionable">
        {this.getTplWaterfall()}
      </div>
    );
  }
}

export default TplWaterfall;

// 获取浏览器窗口宽度
export function getWinWidth() {
  let winWidth = 0;

  if (window.innerWidth) {
    winWidth = window.innerWidth;
  } else if (document.documentElement && document.documentElement.clientWidth) {
    winWidth = document.documentElement.clientWidth;
  }

  return winWidth;
}
